import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ToastService } from '../services/toast.service';

function isJwtExpired(token: string): boolean {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return typeof payload.exp === 'number' && Date.now() >= payload.exp * 1000;
  } catch {
    return false; // non-JWT or malformed — let the server decide
  }
}

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const toast = inject(ToastService);
  const token = localStorage.getItem('sw_token');

  if (!token) {
    toast.warning('Please log in to continue.');
    router.navigate(['/auth/login']);
    return false;
  }

  if (isJwtExpired(token)) {
    const hasRefresh = !!localStorage.getItem('sw_refresh');
    if (!hasRefresh) {
      localStorage.removeItem('sw_token');
      localStorage.removeItem('sw_user');
      toast.warning('Your session has expired. Please log in again.');
      router.navigate(['/auth/login']);
      return false;
    }
    // Refresh token exists — allow navigation; the interceptor will renew on the first 401
  }

  return true;
};
